<template>
  <a-card :bordered="false">
    <a-button type="primary" v-has:antiDocumentsInAdd="()=> {$router.push('/antiFleeingGoods/documents/createInStock?type=add')}">
      <PlusOutlined />
      新建入库单
    </a-button>
    <a-form class="m-b-20 m-t-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.keyword_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="warehousing_sn">入库单号</a-select-option>
            <a-select-option value="product_name">商品名称</a-select-option>
            <a-select-option value="product_batch">生产批次</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item label="入库仓库" name='warehouse_id'>
        <a-select v-model:value="search.warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
     <!-- <a-form-item label="类型" name='create_type'>
        <a-select v-model:value="search.create_type" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">快速入库</a-select-option>
          <a-select-option value="2">按单入库</a-select-option>
        </a-select>
      </a-form-item> -->
           <a-form-item label="状态" name='scan_type'>
        <a-select v-model:value="search.scan_type" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">待入库</a-select-option>
          <a-select-option value="2">已扫码</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='warehousing_sn' :columns='columns' :data-source='list' class="tableFixBox" :scroll="{ x: 'max-content'}">
      <template v-slot:product_name="{ record }">
           <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image_url||record.cover_image_url)" alt=""
                style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>   {{record.product_sku_name || '单规格'}} - {{record.product_name}}</template>
          </a-card-meta>
      </template>
      <template #title_num>
        入库数量
      </template>
          <template #real_code_num>
        实际数量
        <a-tooltip placement='right'>
          <template #title>包装的最小单位数量</template>
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
      <template v-slot:realCodeNum="{ record }">
       <P @click="targetId=record.id;codeDetailVisible=true" style="color:#f04635;cursor: pointer;">{{record.code_num || '-'}}</P>
      </template>
      <template v-slot:action="{ record }">
        <a-button v-has:antiDocumentsInDetail="()=>{orderDetailVisible=true;targetId=record.id}" class="m-r-10">查看详情</a-button>
        <a-button v-has:antiDocumentsInDel='()=>del(record.id)' class="m-r-10" danger>删除</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
  </a-card>
  <!-- 二维码详情 -->
   <a-modal title='入库二维码明细' :keyboard="false" v-model:visible="codeDetailVisible" centered  :width='1300' destroyOnClose :footer='null'>
       <codeDetail :id="targetId"/>
   </a-modal>
   
  <a-modal title='入库单详情' :keyboard="false" :maskClosable='false' v-model:visible="orderDetailVisible" destroyOnClose :footer='null' :width="800" centered>
    <warehousingDetails  :id="targetId" />
  </a-modal>
</template>
<script>
  import { PlusOutlined,InfoCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import store from '@/store'
  import { getWarehouseList,getDocumentWarehousing,delWarehousing } from '@/api/antiFleeing';
  import config from '@/config'
  import codeDetail from './components/codeDetail'
  import warehousingDetails from '../../components/warehousingDetails.vue'
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    scan_type:'',
    warehouse_id: '',
    page: 1,
    limit: 10,
    keyword_type: "warehousing_sn",
    keyword: "",
    // create_type:''
  };
  export default {
    components: {PlusOutlined,InfoCircleOutlined,codeDetail,warehousingDetails},
    setup() {
      const state = reactive({
        time: [],
        warehouseList:[],
        orderDetailVisible:false
      });
      let columns = [
        {
          title: "入库单号",
          dataIndex: "warehousing_sn",
          key: "warehousing_sn",
        },
        {
          title: "入库仓库",
          dataIndex: "warehouse_name",
          key: "warehouse_name",
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
          width:300
        },
        {
          title: "生产批次",
          dataIndex: "product_batch_name",
          key: "product_batch_name",
          customRender:({record})=>{
            return record.product_batch_name ? record.product_batch_name:'-'
          } 
        },
        {
          dataIndex: "warehousing_num",
          key: "warehousing_num",
          slots: { title: 'title_num' }
        },
        {
          dataIndex: "real_code_num",
          key: "real_code_num",
          slots: { title: 'real_code_num',customRender: "realCodeNum" }
        },
           {
          title: "类型",
          dataIndex: "create_type_text",
          key: "create_type_text"
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "操作",
          key: "action",
          fixed:"right",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      // 关闭
      const del = (id) => {
        $Modal.confirm({
          centered: true,
          title:'是否删除入库单？',
          onOk: async () => {
            let res = await delWarehousing(id).then((res) => res.data);
            if (iscode(res, true)) {
              tableHoosks.initData(getDocumentWarehousing, search.value);
            }
          },
        });
      };
      // 二维码详情
      const codeDetailVisible=ref(false)
      const targetId=ref(false)
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        getWarehouse()
        tableHoosks.initData(getDocumentWarehousing, search.value);
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime,
        del,
        info: store.state.user.info,
        codeDetailVisible,
        targetId
      };
    },
  };
</script>